import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { AppConstants } from "../app_setting/app-constants";

import { MasterService } from 'src/app/services/master.service';
import { RegistrationService } from 'src/app/services/registration.service';

import { RegisterCallCenterDialogComponent } from './shared/register-call-center-dialog/register-call-center-dialog.component';
import { RegisterInformationDialogComponent } from './shared/register-information-dialog/register-information-dialog.component';
import { RegisterTncDialogComponent } from './shared/register-tnc-dialog/register-tnc-dialog.component';

import { BusinessType, Province } from 'src/app/models/master';
import { RegisterCompanyRequest, RegisterUserRequest, RegisterTaxpayerRequest } from 'src/app/models/account';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class RegisterComponent implements OnInit {

  registerCompanyRequest: RegisterCompanyRequest = new RegisterCompanyRequest();
  registerUserRequest: RegisterUserRequest = new RegisterUserRequest();
  registerTaxpayerRequest: RegisterTaxpayerRequest = new RegisterTaxpayerRequest();

  public currentStep: string = 'business-profile';
  public businessTypes: BusinessType[] = [];
  public provinces: Province[] = [];
  public tncContent: any;
  public submitting: boolean = false;
  public memberID: string;
  public popup_message_registration: any;
  public popup_message_registration_npwp: any;
  public popup_message_registration_success: any;
  private officeID: string;
  private shippingAddressID: string;
  private token: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private masterService: MasterService,
    private registrationService: RegistrationService,
  ) {
    localStorage.setItem(AppConstants.RegisterTokenId, route.snapshot.data.token);
    this.popup_message_registration = route.snapshot.data.popup_message_registration;
    this.popup_message_registration_npwp = route.snapshot.data.popup_message_registration_npwp;
    this.popup_message_registration_success = route.snapshot.data.popup_message_registration_success;
  }

  ngOnInit() {
    this.getBusinessTypes();
    this.getProvinces();
    this.getTncContent();

    this.registerUserRequest.is_same_address = true;
    this.registerTaxpayerRequest.has_npwp = true;
    this.registerTaxpayerRequest.is_non_pkp = true;

    // show dialog register information
    setTimeout(() => {
      const modalRef = this.modalService.open(RegisterInformationDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "register-information-dialog", backdrop: 'static' });
      modalRef.componentInstance.content = this.popup_message_registration;
    }, 0);
  }

  nextStep($event: { step: string; data: any }) {
    if ($event.step === "business-profile") {
      this.registerCompanyRequest = $event.data;
      this.submitCompanyData();
    } else if ($event.step === "user-profile") {
      this.registerUserRequest = $event.data;
      this.submitUserData();
    } else {
      this.registerTaxpayerRequest = $event.data;
      if (!this.registerTaxpayerRequest.has_npwp || this.registerTaxpayerRequest.is_non_pkp) {
        this.showTaxpayerAlert();
      } else {
        this.submitTaxpayerData();
      }
    }
  }

  prevStep($event: { step: string; data: any }) {
    if ($event.step === "taxpayer-profile") {
      this.registerTaxpayerRequest = $event.data;
      this.currentStep = "user-profile";
      window.scroll({
        top: 0
      });
    } else if ($event.step === "user-profile") {
      this.registerUserRequest = $event.data;
      this.currentStep = "business-profile";
      window.scroll({
        top: 0
      });
    }
  }

  onBack() {
    if (this.currentStep === "taxpayer-profile") {
      this.currentStep = "user-profile";
      window.scroll({
        top: 0
      });
    } else if (this.currentStep === "user-profile") {
      this.currentStep = "business-profile";
      window.scroll({
        top: 0
      });
    } else {
      this.router.navigate(['/home']);
    }
  }

  getTncContent() {
    this.masterService.getTermsAndConditions(
      (data) => {
        if (data.items.length > 0) {
          this.tncContent = data.items[0];
        }
      },
      (err) => {
        console.log("error: ", err);
      });
  }

  getBusinessTypes() {
    this.masterService.getBusinessTypes(
      (data) => {
        this.businessTypes = data;
      },
      (err) => {
        console.log(err);
      });
  }

  getProvinces() {
    this.masterService.getProvinces(
      (data) => {
        this.provinces = data;
      },
      (err) => {
        console.log(err);
      });
  }

  showTaxpayerAlert() {
    const modalRef = this.modalService.open(RegisterInformationDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "register-information-dialog", backdrop: 'static' });
    modalRef.componentInstance.content = this.popup_message_registration_npwp;
    modalRef.result.then(() => {
      this.submitTaxpayerData();
    }, function dismiss() { });
  }

  showRegisterSuccessAlert() {
    const modalRef = this.modalService.open(RegisterInformationDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "register-information-dialog", backdrop: 'static' });
    modalRef.componentInstance.content = this.popup_message_registration_success;
  }

  openTNCDialog() {
    const modalRef = this.modalService.open(RegisterTncDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "register-information-dialog", backdrop: 'static' });
    modalRef.componentInstance.data = this.tncContent;
  }

  submitCompanyData() {
    this.submitting = true;
    this.registrationService.submitCompanyData(
      this.officeID,
      this.registerCompanyRequest,
      (data) => {
        this.currentStep = "user-profile";
        window.scroll({
          top: 0
        });
        this.officeID = data.officeId;
        this.submitting = false;
      },
      (err) => {
        this.submitting = false;
        if (err.error && err.error.alert && err.error.alert.data) {
          const modalRef = this.modalService.open(RegisterCallCenterDialogComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, windowClass: "register-information-dialog", backdrop: 'static' });
          modalRef.componentInstance.data = err.error.alert.data;
        } else {
          let errMessage = "Terjadi kesalahan.";
          if (err.error && err.error.alert) {
            errMessage = err.error.alert.message;
          }
          this.toastr.error(errMessage, '', {
            timeOut: 3000
          });
        }
      });
  }

  submitUserData() {
    this.submitting = true;
    this.registrationService.submitUserData(
      this.officeID,
      this.memberID,
      this.registerUserRequest,
      (data) => {
        this.memberID = data.memberId;
        this.submitShippingAddressData();
      },
      (err) => {
        this.submitting = false;
        let errMessage = "Terjadi kesalahan.";
        if (err.error && err.error.alert) {
          errMessage = err.error.alert.message;
        }
        this.toastr.error(errMessage, '', {
          timeOut: 3000
        });
      });
  }

  submitShippingAddressData() {
    let latitude;
    let longitude;
    let params: any = {};
    if (this.registerUserRequest.is_same_address) {
      let coordinate = this.registerCompanyRequest.coordinate.split(",");
      if (coordinate.length === 2) {
        latitude = coordinate[0];
        longitude = coordinate[1];
      }

      params = {
        memberId: this.memberID,
        province: this.registerCompanyRequest.province_id,
        city: this.registerCompanyRequest.regency_id,
        district: this.registerCompanyRequest.district_id,
        village: this.registerCompanyRequest.village_id,
        postCode: this.registerCompanyRequest.postal_code,
        long: longitude,
        lat: longitude,
        address: this.registerCompanyRequest.business_address,
        rt: this.registerCompanyRequest.neighbourhood,
        rw: this.registerCompanyRequest.hamlet,
      };

      if (this.shippingAddressID) {
        params.shippingAddressId = this.shippingAddressID;
      }
    } else {
      let coordinate = this.registerUserRequest.coordinate.split(",");
      if (coordinate.length === 2) {
        latitude = coordinate[0];
        longitude = coordinate[1];
      }

      params = {
        memberId: this.memberID,
        province: this.registerUserRequest.province_id,
        city: this.registerUserRequest.regency_id,
        district: this.registerUserRequest.district_id,
        village: this.registerUserRequest.village_id,
        postCode: this.registerUserRequest.postal_code,
        long: longitude,
        lat: longitude,
        address: this.registerUserRequest.delivery_address,
        rt: this.registerUserRequest.neighbourhood,
        rw: this.registerUserRequest.hamlet,
        warehouseLicenseFile: this.registerUserRequest.warehouse_license_file,
      };

      if (this.shippingAddressID) {
        params.shippingAddressId = this.shippingAddressID;
      }
    }

    this.registrationService.submitShippingAddressData(
      params,
      (data) => {
        this.shippingAddressID = data.shippingAddressId;
        this.currentStep = "taxpayer-profile";
        window.scroll({
          top: 0
        });
        this.submitting = false;
      },
      (err) => {
        this.submitting = false;
        let errMessage = "Terjadi kesalahan.";
        if (err.error && err.error.alert) {
          errMessage = err.error.alert.message;
        }
        this.toastr.error(errMessage, '', {
          timeOut: 3000
        });
      });
  }

  submitTaxpayerData() {
    this.submitting = true;
    this.registrationService.submitTaxpayerData(
      this.memberID,
      this.registerTaxpayerRequest,
      (data) => {
        this.submitting = false;
        this.showRegisterSuccessAlert();
      },
      (err) => {
        this.submitting = false;
        let errMessage = "Terjadi kesalahan.";
        if (err.error && err.error.alert) {
          errMessage = err.error.alert.message;
        }
        this.toastr.error(errMessage, '', {
          timeOut: 3000
        });
      });
  }

}
